import { SET_SEAT_OPTIONS, POSITION_SEAT_OPTION, UPDATE_SEAT_OPTION } from './types';
import { sortSeatOptionsByIndex } from './utils';

const initialState = {};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case SET_SEAT_OPTIONS: {
    // Add index field to each seat option, defaulting to current position if not present
    const entries = Object.entries(payload);
    return Object.fromEntries(
      entries.map(([key, value], index) => [
        key,
        { ...value, index: value.index ?? index },
      ]),
    );
  }

  case POSITION_SEAT_OPTION: {
    const { sourceIndex, destinationIndex } = payload;
    // Convert state to array and sort by current index to ensure correct order
    let entries = sortSeatOptionsByIndex(state);
    const removed = entries[sourceIndex];
    entries = entries.filter((entry) => entry !== removed);
    const newEntries = [
      ...entries.slice(0, destinationIndex),
      removed,
      ...entries.slice(destinationIndex),
    ];
    // Update index for all entries
    return Object.fromEntries(
      newEntries.map(([key, value], index) => [
        key,
        { ...value, index },
      ]),
    );
  }

  case UPDATE_SEAT_OPTION: {
    const { seatType, data } = payload;
    // Preserve the index when updating other properties
    const currentIndex = state[seatType]?.index ?? Object.keys(state).indexOf(seatType);
    return {
      ...state,
      [seatType]: { ...state[seatType], ...data, index: currentIndex },
    };
  }

  default: {
    return state;
  }
  }
};
